<template>
  <!-- Main Content  -->
  <div class="container">
    <section class="content-header">
      <h1>{{$t('登録情報の変更')}}</h1>
    </section>

    <div class="loader" v-if="this.dataloading">
      <div class="loader-inner ball-scale-multiple">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>    
    <section v-else class="content-wrap">
      <div class="setting">

        <!-- common error messages -->
        <div class="warning" id="warning" v-if="commonErrors.length">
          <ul>
            <li v-for="(error, index) in commonErrors" :key="index">{{ error }}</li>
          </ul>
        </div>

        <div class="col-setting-left">
          <div class="col-setting">
          <!-- edit email address -->
          <h2 v-if="! this.$store.getters.email">{{ $t('メールアドレスの登録') }}</h2>
          <h2 class="profTitle" v-else>{{ $t('メールアドレスの変更') }}</h2>

            <form class="mail-confing" @submit.prevent="modifyEmail">
              
              <div>
                <h3 class="profSubTitle" v-if="this.$store.getters.email">{{ $t('現在のメールアドレス') }}</h3>
                <p v-if="this.$store.getters.email">{{ this.$store.getters.email }}</p>
              </div>
              
              <h3 class="profSubTitle">{{$t('新しいメールアドレス')}}：</h3>
              <input name="email" type="text" v-on:blur="instantValidator($event, 'email')" v-on:change="instantValidator($event, 'email')" v-model="email" :placeholder="$t('新しいメールアドレス')">
              <span v-if="commonErrors.hasOwnProperty('email')" style="color:red;">{{ commonErrors.email }}</span>

              <button v-bind:style="[commonErrors.hasOwnProperty('email') ? {'pointer-events':'none', 'background-color':'#c9cbcc'} : {}]" type="submit" >{{ $t('変更する') }}</button>
            </form>
          </div>

          <!-- edit newsletter flag -->
          <div class="col-setting">
            <h2 class="profTitle">{{ $t('メールマガジンの購読') }}</h2>
            <div class="col-center">
              <form @submit.prevent="updateNewsletter">
                <input type="radio" name="newsletter" id="newsletter_on" value="1" v-model="profiles.newsletter" @click="newsletterChangeEmitator" />
                <label for="newsletter_on">{{$t('購読する')}}</label>
                <br>
                <input type="radio" name="newsletter" id="newsletter_off" value="0" v-model="profiles.newsletter" @click="newsletterChangeEmitator" />
                <label for="newsletter_off">{{$t('購読しない')}}</label>
                <button id="send-event" v-bind:style="[!newsletterChangeEmit ? {'pointer-events':'none', 'background-color':'#c9cbcc'} : {}]" type="submit">{{$t('変更する')}}</button>
              </form>
            </div>
          </div>
        </div>

        <div class="col-setting-right">
          <!-- edit profile -->
          <div class="col-setting">
            <h2 class="profTitle">{{ $t('任意の項目') }}</h2>
            <div>
              <form @submit.prevent="editProfile">
                <p>{{ $t('ご希望の表示言語') }}</p>
                <div>
                  <label class="settingSelect">
                  <select v-model="profiles.language_id">
                    <option v-for="(language, key) in languages" v-bind:value="key" v-bind:key="key">{{ language  }}</option>
                  </select>
                  </label>
                </div>

                <p>{{ $t('名') }}</p>
                <div><input type="text" v-model="profiles.user_first_name" :placeholder="$t('名')" /></div>

                <p>{{ $t('姓') }}</p>
                <div><input type="text" v-model="profiles.user_family_name" :placeholder="$t('姓')" /></div>

                <p>{{ $t('誕生日') }}</p>
     
                <span v-if="commonErrors.hasOwnProperty('birthday')" style="color:red;">{{ commonErrors.birthday }}</span>

                <div class="birthSelect">
                  <label class="settingSelect">
                    <select name="birthday_m" v-model="birthday_m" v-on:change="instantValidator($event, 'birthday')">
                      <option v-for="month in months" v-bind:value="month" v-bind:key="month">{{ month }}</option>
                    </select>
                  </label>

                  <label class="settingSelect">
                    <select name="birthday_d" v-model="birthday_d" v-on:change="instantValidator($event, 'birthday')">
                      <option v-for="day in days" v-bind:value="day" v-bind:key="day">{{ day }}</option>
                    </select>
                  </label>

                  <label class="settingSelect">
                    <select name="birthday_y" v-model="birthday_y" v-on:change="instantValidator($event, 'birthday')">
                      <option v-for="year in years" v-bind:value="year" v-bind:key="year">{{ year }}</option>
                    </select>
                  </label>
                </div>

                <div>
                  <p>{{ $t('性別') }}</p>
                  <p>
                    <input type="radio" name="gender" value="male" id="male" v-model="profiles.gender" />
                    <label for="male">{{$t('男')}}</label>
                    <input type="radio" name="gender" value="female" id="female" v-model="profiles.gender" />
                    <label for="female">{{$t('女')}}</label>
                    <input type="radio" name="gender" value="other" id="other" v-model="profiles.gender" />
                    <label for="other">{{$t('その他')}}</label>
                  </p>
                </div>

                <p>{{ $t('国籍') }}</p>
                <div>
                  <label class="settingSelect">
                    <select name="country_code" v-model="profiles.country_code">
                      <option value="" selected disabled>{{ $t('国籍') }}</option>
                      <option v-for="nationality in nationalities" v-bind:value="nationality.country_code" v-bind:key="nationality.country_code">{{ nationality.nationality_name }}</option>
                    </select>
                  </label>
                </div>

                <p>{{ $t('これらの情報は本サービスを改善するための解析用です。他ユーザーに共有されることはありません。') }}</p>

                <button type="submit">{{$t('変更する')}}</button>
              </form>
            </div>
          </div>

          <div class="col-setting">
          <!-- delete account -->
             <p class="settingDelete"><a class="arrowRight" :href="'/deleteaccount'">{{$t('アカウントの削除')}}</a></p>
          </div>
        </div>
      </div>
    </section>
  </div>
  <!-- Main Content -->
</template>


<script>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import User from '@/api/user'
import Cookie from 'js-cookie'
import * as constants from '@/constants'
import UserUtils from '@/utils/UserUtils'


export default {
  mounted(){
    this.$gtm.trackView('ProfileSettings', 'currentpath');
    // get profiles
    User
      .getUserMeta()
      .then(response => {
        this.profiles = response.data.data[0]
        this.profiles.newsletter = this.profiles.newsletter === null ? 0 : this.profiles.newsletter
        if (this.profiles.birthday !== null) {
          let bDay = UserUtils.getDate(this.profiles.birthday)
          // console.log(bDay)
          this.birthday_y = parseInt(bDay.year)
          this.birthday_m = parseInt(bDay.month)
          this.birthday_d = parseInt(bDay.day)
        }
        this.dataloading = false
      })
      .catch(error => {
        this.dataloading = false
        // console.log(error.response)
      })
  },
  data: () => ({
    dataloading: true,
    languages: UserUtils.getLanguages(),
    years:  [...Array(100).keys()].map(i => (new Date()).getFullYear() - i).reverse(), 
    months: [...Array(12).keys()].map(i => i + 1), 
    days:   [...Array(31).keys()].map(i => i + 1),
    email: null,
    profiles : {
      newsletter: null,
      birthday: ''
    },
    nationalities: null,
    birthday_y : '',
    birthday_m : '',
    birthday_d : '',
    country : null,
    newsletterChangeEmit: '',
    commonErrors: []
  }),
  
  computed:{
    ...mapState(['clips', 'user']),
    ...mapGetters({
      accessToken: 'accessToken',
      userId: 'userId',
      userAttributes: 'userAttributes'
    })
  },

  created() {
    // ISO 3166-1準拠の国名を取得
    User.getNationality().then(response => this.nationalities = response.data)
  },

  methods:{
    /**
     * regist and modify email
     */
    modifyEmail() {
      this.commonErrors = [];

      // if (this.errors.has('email')) return
      if(this.email === null){
        // console.log(this.email)
        this.commonErrors.email =  this.$t('Email field is empty.')
        return
      }else if(!this.emailValidator(this.email)){
          this.commonErrors.email = this.$t("Invalid email adrress.")
      }else{
        let sns_registration = Cookie.get('CognitoIdentity.sns_registration')
        // Save Email Only In case of SNS_USER
        if(this.$store.state.userMeta.sns_registration || sns_registration === 'true'){
          // console.log('SNS')
          let bodyParams = {
            user_id: this.userId,
            accessToken: this.accessToken,
            email: this.email,
            sns_registration: true
          }

          User.updateUserMeta(bodyParams).then(response => {
            if (response.status === 200) {
              this.$swal({
                text: this.$t('Your email address has been changed successfully!'),
                type: 'success'
              }).then(()=>{
                window.location.reload()
              })
              
            }
          })
          .catch(error => {
            // console.log(error.response)
            this.commonErrors.email = this.$t('Something going to be wrong! Please try later.')
          })

          return
        }else{
          let bodyParams = {
            userId: this.userId,
            accessToken: this.accessToken,
            newEmail: this.email,
            sns_registration: false
          }

          User
            .modifyEmailAttributes(bodyParams)
            .then(response => {
              // console.log(response)
              if (response.status === 200) {
                window.localStorage.setItem('newEmailForVerification', btoa(JSON.stringify(this.email)))
                window.location.href = '/confirm'
              }
            })
          .catch(error => {
            // console.log(error.response)
            // add error messages 
            let error_info = (error.response !== undefined)?error.response:(error.response.data !== undefined)?error.response.data:error.errors
            ['accessToken', 'email', 'user_id'].map(val => {
              const message = this.getNestedObject(error_info, ['errors', 'message', 0, val, 0])
              if (message !== undefined) {
                this.commonErrors.email = this.$t(message) || message
              }
            });

            const errorMsg = this.getNestedObject(error.errors, ['message', 0])
            if (errorMsg !== undefined) {
              this.commonErrors.email = this.$t(errorMsg) || errorMsg 
            }
          })        
        }

      }

    },


    /**
     * Notify Newsletter Change Emitter
     */
    newsletterChangeEmitator(e){
      this.newsletterChangeEmit = 'changed'
    },

    /**
     * update newsletter flag
     */
    updateNewsletter() {
      this.commonErrors = [];
      if(!this.newsletterChangeEmit) return

      let sns_registration = this.$store.state.userMeta.sns_registration
      let bodyParams = {
        user_id: this.userId,
        accessToken: this.accessToken,
        newsletter : parseInt(this.profiles.newsletter),
        sns_registration: sns_registration
      }

      User
        .updateUserMeta(bodyParams)
        .then(response => {
          if (response.status !== 200) {
            throw new Exception();
          }

        this.$swal({
          text: this.$t('登録内容が変更されました。引き続き、WEBマガジンMATCHAをお楽しみ下さい。'),
          type: 'success'
        })
      })
      .catch(error => {
        this.commonErrors.newsletter = this.$t('Something going to be wrong! Please try later.')
      })
    },

    /**
     * edit profile
     */
    editProfile() {
      this.commonErrors = [];

      let sns_registration = this.$store.state.userMeta.sns_registration
      let bodyParams = {
        user_id: this.userId,
        accessToken: this.accessToken,
        language_id : this.profiles.language_id,
        country_code : this.profiles.country_code,
        user_first_name : this.profiles.user_first_name,
        user_family_name : this.profiles.user_family_name,
        birthday : `${this.birthday_y}-${String(this.birthday_m).padStart(2, 0)}-${String(this.birthday_d).padStart(2, 0)}`, 
        gender : this.profiles.gender,
        sns_registration: sns_registration
      }
      
      if (!this.birthday_y || !this.birthday_m || ! this.birthday_d ) {
        delete bodyParams.birthday
      } 

      User
        .updateUserMeta(bodyParams)
        .then(response => {
          if (response.status !== 200) {
            // console.log(response)
            throw new Exception();
          }

          this.$swal({
            text: this.$t('Your information has been updated successfully!'),
            type: 'success'
          }).then(()=>{
            let newLangName =  UserUtils.convertToLanguageName(this.getNestedObject(response.data, ['data', 'meta', 0, 'language_id']))
            this.languageSwitching(newLangName)
          })

        })
        .catch(error => {
          this.commonErrors.profile = this.$t('Something going to be wrong! Please try later.')
        })
    },

    getNestedObject: function(nestedObj, pathArr){
      return pathArr.reduce((obj, key) => (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj);
    },
    languageSwitching: function(languageName) {
      this.$i18n.locale = languageName
      this.languageName = languageName
      document.body.className = languageName
    },


    /**
     * Data & Input Validation Section 
     */
    instantValidator(el, type){
      // console.log(this.commonErrors.email)
      if(!type) return
      if(type === 'email'){
        this.email = el.target.value
        if(!this.email){
          this.commonErrors.email = this.$t("Invalid email adrress.")
        }else if(!this.emailValidator(this.email)){
          this.commonErrors.email = this.$t("Invalid email adrress.")
        }else if(this.email === this.$store.state.user.email){
          this.commonErrors.email = this.$t("The email address has already been taken.")
        }else{
          this.commonErrors = []
          return
        }
        el.preventDefault();
      }else if(type === 'birthday'){
        if(!this.birthday_y || !this.birthday_m || !this.birthday_d){
          this.commonErrors.birthday = this.$t("Invalid Format! Must select each of Month, Date & Year.")
        }else{
          this.commonErrors = []
          return
        }
      }else{
        this.commonErrors = []
        return
      }
    },
    validEmail:function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    emailValidator:function(email) {
      if (!email) return false;
      if (email === this.$store.state.user.email) return false
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email);
    },
  },


  //For Header & Meta Tag 
  metaInfo() {
    return {
      title: this.$t('登録情報の変更') + ' | '+ this.$t('MATCHA - JAPAN TRAVEL WEB MAGAZINE'),
      htmlAttrs: {
        lang: this.$store.state.languageName
      },      
    }
  },   
}

</script>



// WEBPACK FOOTER //
// src/pages/settings/index.vue